module.exports = __webpack_public_path__ + "static/media/triangle_selected.9d6a5ee9.png";